// src/components/HeroCarousel.js
import React from 'react';
import './HeroCarousel.css';

const HeroCarousel = () => {
  return (
    <div className="hero-container">
      <div className="slide" style={{ backgroundImage: `url('/images/portada1.jpg')` }}>
        <div className="slide-content">
          <h1>Calidad y placer a la hora de comer</h1>
          <a href="/catalogo" className="cta-button">VER PRODUCTOS</a>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;